import { LoadingWave } from '@/components/Charts/LoadingWave';

import { classNames } from '@/utils/classnames';

type TokenPriceChartLoadingProps = {
  height: number;
  showTimeframes?: boolean;
  showMetricSelector?: boolean;
  enableCandlestickView?: boolean;
};

export const TokenPriceChartLoading = ({
  height,
  showTimeframes = false,
  showMetricSelector = false,
  enableCandlestickView = false,
}: TokenPriceChartLoadingProps) => (
  <div
    className={classNames(
      'w-full',
      { 'pb-10.5': showTimeframes },
      { 'pt-7': showMetricSelector && !enableCandlestickView },
      { 'pt-10.5': enableCandlestickView },
    )}
  >
    <div className="w-full" style={{ height }}>
      <LoadingWave />
    </div>
    <span className="sr-only">Loading price chart</span>
  </div>
);
